import React from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

interface EmptyStateComponentProps {
  title?: string;
  text?: string;
  titleClassName?: string;
  textClassName?: string;
  className?: string;
  ctaButton?: React.ReactElement;
  testID?: string;
}

const EmptyStateComponent: React.FC<EmptyStateComponentProps> = ({
  title,
  text,
  ctaButton,
  titleClassName,
  textClassName,
  className,
  testID,
}) => {
  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center min-h-[380px]',
        className,
      )}
      data-testid={testID}
      data-test-component={'empty-state'}
    >
      <h2
        className={twJoin(
          'text-center text-charcoal-gray text-h2 font-medium mb-3',
          titleClassName,
        )}
      >
        {title}
      </h2>
      <p
        className={twMerge(
          'font-medium max-w-[752px] text-center text-h6 text-med-gray-3',
          textClassName,
        )}
      >
        {text}
      </p>
      {!!ctaButton && (
        <div className="flex flex-row w-full desktop:w-auto">{ctaButton}</div>
      )}
    </div>
  );
};

export default EmptyStateComponent;
